<um-nav-bar [currentUser]="currentUser" [pageTitle]="activePageTitle"></um-nav-bar>
<div class="overflow-container">
    <nav mat-tab-nav-bar class="px-5">
        <ng-container *ngFor="let link of tabIndexes">
            <a mat-tab-link *ngIf="permissionsList[link.name]" tabindex="-1" [routerLink]="[link.url]" routerLinkActive="mat-tab-label-active"
                [active]="router.isActive(link.url, false)"> {{link.label}} </a>
        </ng-container>
    </nav>
    <router-outlet></router-outlet>
</div>